import { useAtomValue } from 'jotai';

import useHandleResizedImage from '../../../../../hooks/useHandleResizedImage';
import { CommonAnnotationLayerProps } from '../index.types';
import { currentPageAtom } from '../../../../../store/index.atom';
import MobileHyperLinkLayer from '../../HyperLinkLayer/Mobile';

export interface MobileAnnotationLayerProps extends CommonAnnotationLayerProps {
  isPreview?: boolean;
}

const MobileAnnotationLayer = ({
  thumnail,
  isPreview = false,
}: MobileAnnotationLayerProps) => {
  const currentPage = useAtomValue(currentPageAtom);

  const { hyperlink, originalWidth, originalHeight } =
    thumnail[currentPage - 1];

  const { resizedImageSize } = useHandleResizedImage({
    originalHeight,
    originalWidth,
  });

  return (
    <>
      <MobileHyperLinkLayer
        hyperlinkList={hyperlink}
        resizedImageSize={resizedImageSize}
        isPreview={isPreview}
      />
    </>
  );
};

export default MobileAnnotationLayer;
